export default __webpack_public_path__ + "static/media/up_arrow.e204ef86.svg";